import handler from 'api/handler'

const prefix = '/public/functionalArea'

const methods = {
  getArea: args => handler({ method: 'get', url: `${prefix}/areas`, params: args }),
}

export default methods
